// Configuração das URLs das App Stores
export const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/br/app/coffeein-club/id6754468778',
  android: 'https://play.google.com/store/apps/details?id=com.coffeeinclub.coffeeinclub',
  fallback: 'https://coffeein.club' // URL de fallback
};

// Configuração do deep linking
export const DEEP_LINK_SCHEME = 'coffeepass';

// URLs de fallback para diferentes dispositivos
export const FALLBACK_URLS = {
  ios: APP_STORE_URLS.ios,
  android: APP_STORE_URLS.android,
  desktop: APP_STORE_URLS.fallback
};

// Configuração de timeout para tentativa de abrir o app
export const APP_OPEN_TIMEOUT = 2000; // 2 segundos

